"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import React, { memo, FC } from 'react';
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const material_1 = require("@mui/material");
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const KeyboardArrowLeft_1 = __importDefault(require("@mui/icons-material/KeyboardArrowLeft"));
const KeyboardArrowRight_1 = __importDefault(require("@mui/icons-material/KeyboardArrowRight"));
const QButton_1 = __importDefault(require("components/QButton"));
const SearchBox_1 = __importDefault(require("components/SearchBox"));
const scheduledTransactionsTypes_1 = require("companion-app-components/flux/scheduled-transactions/scheduledTransactionsTypes");
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const ScheduledTxnsAppBar = ({ sliderActive, uiState, setUIState, isFormDirty, onAddClick, sortDueDate, setSortDueDate, globalSearch, setGlobalSearch, editMode, selectTransaction, setIsConfirmationDialogOpen, setDiscardCb, addMenu, setAddMenu, setIsFormDirty, setEditMode, }) => {
    const { classes } = useStyles();
    const closeSchTxnForm = () => {
        setUIState({ scheduledTransaction: undefined });
        setEditMode(false);
        setIsFormDirty(false);
    };
    const showConfirmationDialog = (isConfirmationDialogOpen, discardCb) => {
        setIsConfirmationDialogOpen(isConfirmationDialogOpen);
        setDiscardCb(discardCb);
    };
    const handleAddMenuOpen = (event) => setAddMenu(event.currentTarget);
    const handleAddMenuClose = (callback) => () => {
        setAddMenu(null);
        if (callback) {
            callback();
        }
    };
    return (<material_1.AppBar position="sticky" elevation={0} className={classes.appBar} style={{ height: 48 }}>
      <div className={classes.appBarGridContainer}>
        <material_1.Tabs value={uiState.filterTab} onChange={(event, value) => {
            if (isFormDirty) {
                showConfirmationDialog(isFormDirty, () => {
                    setUIState({ filterTab: value });
                    closeSchTxnForm();
                });
                return;
            }
            if (uiState.filterTab !== value && uiState.scheduledTransaction) {
                closeSchTxnForm();
            }
            setUIState({ filterTab: value });
        }} indicatorColor="primary" variant="scrollable" scrollButtons="auto" 
    // eslint-disable-next-line react/no-unstable-nested-components
    ScrollButtonComponent={(scrollProps) => {
            const isLeft = scrollProps.direction === 'left';
            const clsNames = (0, classnames_1.default)(classes.tabBarArrowButtons, (isLeft ? classes.arrowLeft : classes.arrowRight));
            if (!scrollProps.visible) {
                return <div className={clsNames}/>;
            }
            return (<material_1.ButtonBase component="div" className={clsNames} onClick={scrollProps.onClick}>
                {isLeft ? <KeyboardArrowLeft_1.default fontSize="small"/> : <KeyboardArrowRight_1.default fontSize="small"/>}
              </material_1.ButtonBase>);
        }} textColor="primary" classes={{
            flexContainer: classes.tabBar,
        }}>
          <material_1.Tab label="All" id="all-tab" value="all" classes={{ root: classes.tab }}/>
          <material_1.Tab label="Bills" id="bills-tab" value={scheduledTransactionsTypes_1.STTypeEnum.EXPENSE} classes={{ root: classes.tab }}/>            
          <material_1.Tab label="Income" id="income-tab" value={scheduledTransactionsTypes_1.STTypeEnum.INCOME} classes={{ root: classes.tab }}/>
          <material_1.Tab label="Transfers" id="transfer-tab" value={scheduledTransactionsTypes_1.STTypeEnum.TRANSFER} classes={{ root: classes.tab }}/>
        </material_1.Tabs>

        <div className={classes.rightContent}>
          <div className={classes.sortToggleRoot}>
            <div className={classes.sortLabel}>
              Sort by Due Date
            </div>
            <material_1.Switch id="sort-due-date-toggle" color="primary" checked={sortDueDate} value={sortDueDate ? 'on' : 'off'} onChange={(event, checked) => setSortDueDate(checked)}/>
          </div>
          {(!sliderActive || !editMode) && (<>
              <QButton_1.default id="add-bill-button" variant="contained" onClick={handleAddMenuOpen}>
                <Add_1.default className={classes.iconSpacing}/> Add
              </QButton_1.default>
              <material_1.Menu id="add-transaction-menu" anchorEl={addMenu} keepMounted open={Boolean(addMenu)} onClose={handleAddMenuClose(null)}>
                <material_1.MenuItem id="find-from-transactions" onClick={handleAddMenuClose(onAddClick)}>
                  Find from transactions
                </material_1.MenuItem>
                <material_1.MenuItem id="add-manually" onClick={handleAddMenuClose(selectTransaction)}>
                  Add manually
                </material_1.MenuItem>
              </material_1.Menu>
            </>)}
          <div className={classes.verticalDivider}/>
          <SearchBox_1.default onSearch={(s) => setGlobalSearch === null || setGlobalSearch === void 0 ? void 0 : setGlobalSearch(s === null || s === void 0 ? void 0 : s.toLowerCase())} initialValue={globalSearch} autoSearch autoFocus collapsable/>
        </div>

      </div>
    </material_1.AppBar>);
};
exports.default = ScheduledTxnsAppBar;
